export const PROFILE_CARD = {
  HEADER: {
    LABEL: '{{lastName}} {{firstName}}',
  },
  SUBHEADER: {
    GRADE: '{{grade}}',
    GRADE_DATE: '{{gradeAppointmentDate}}',
  },
};
